class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  async renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    const sectionsToRender = this.getSectionsToRender();
    const sections = { ...(parsedState.sections || {}) };
    const missingSectionIds = sectionsToRender
      .filter((section) => !sections[section.id])
      .map((section) => section.id);

    if (missingSectionIds.length) {
      try {
        const sectionsUrl = new URL(window.location.href);
        sectionsUrl.searchParams.set('sections', missingSectionIds.join(','));

        const response = await fetch(sectionsUrl.toString(), {
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        });

        if (response.ok) Object.assign(sections, await response.json());
      } catch (error) {
        console.error('Unable to refresh cart notification sections.', error);
      }
    }

    sectionsToRender.forEach((section) => {
      const target = document.getElementById(section.id);
      const sectionHTML = this.getSectionInnerHTML(sections[section.id], section.selector);

      if (target && sectionHTML !== null) target.innerHTML = sectionHTML;
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    if (!html) return null;

    const element = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return element ? element.innerHTML : null;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
